import httpClient from 'http/httpClient';

import { ChannelColorsResponse } from 'types/colors';

export const getChannelColors = async () => {
  const { data } = await httpClient.get<ChannelColorsResponse>('/colors');
  return data;
};
